import type { Store } from './store';

interface SeedNode {
  title: string;
  icon?: string;
  children?: SeedNode[];
}

/**
 * Demo workspace for first runs, demos and tests. Grows with each phase
 * (content in Phase 1, tasks and projects in Phase 3).
 */
export const SAMPLE_WORKSPACE: SeedNode[] = [
  {
    title: 'Cockpit',
    icon: '🧭',
    children: [
      { title: 'Inbox', icon: '📥' },
      { title: 'Dagnotities', icon: '📅' },
    ],
  },
  {
    title: 'Projecten',
    icon: '🚀',
    children: [
      { title: 'Project Alpha', children: [{ title: 'Kick-off vergadering' }] },
      { title: 'Website vernieuwen' },
    ],
  },
  {
    title: 'Kennisbank',
    icon: '📚',
    children: [{ title: 'Sneltoetsen' }, { title: 'Werkwijze' }],
  },
];

export async function seedWorkspace(store: Store, nodes: SeedNode[] = SAMPLE_WORKSPACE) {
  const add = async (list: SeedNode[], parentId: string | null) => {
    for (const n of list) {
      const page = await store.createPage({ title: n.title, parentId, icon: n.icon ?? null });
      if (n.children) await add(n.children, page.id);
    }
  };
  await add(nodes, null);
}
